<template>
    <div class="absolute inset-0">
        <img
            :src="hud"
            alt=""
            class="pointer-events-none absolute top-0 left-1/2 max-w-none -translate-x-1/2"
        />
        <KillerSkullIcon :color="color" class="absolute inset-x-0 top-[56px] mx-auto w-[47px]" />
        <div class="absolute inset-x-0 top-[175px] flex justify-center">
            <KillerAvatarFrame :color="color" class="w-[226px]">
                <KillerCrossIcon :color="color" class="w-[82%]" />
            </KillerAvatarFrame>
        </div>
        <h2
            class="font-title absolute inset-x-0 top-[460px] text-center text-[16px] leading-none font-bold text-white uppercase"
        >
            {{ player.tag_name }}
        </h2>
        <KillerHudBrackets :bracket-width="34" :gap="27" class="absolute inset-x-0 top-[500px]">
            <KillerBadge
                :avatar="player.avatar"
                :color="color"
                :label="$t('killer.game_over')"
                class="w-[145px]"
            />
        </KillerHudBrackets>
    </div>
</template>

<script>
import KillerAvatarFrame from '../ui/KillerAvatarFrame.vue'
import KillerBadge from '../ui/KillerBadge.vue'
import KillerCrossIcon from '../ui/KillerCrossIcon.vue'
import KillerHudBrackets from '../ui/KillerHudBrackets.vue'
import KillerSkullIcon from '../ui/KillerSkullIcon.vue'
import hud from '@/assets/images/games/killer/splash/hud-killed.svg'

export default {
    name: 'KillerSplashEliminated',
    components: {
        KillerAvatarFrame,
        KillerBadge,
        KillerCrossIcon,
        KillerHudBrackets,
        KillerSkullIcon,
    },
    props: {
        player: {
            type: Object,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            hud,
        }
    },
}
</script>
